export default __webpack_public_path__ + "static/gold_fish_(purple)-412d4cd8253e28db4a6249286adaea50.png";